import React, { useEffect } from 'react';
import { getTransactionDetail } from '../../../../store/actions/transactionDetail';
import { useDispatch, useSelector } from 'react-redux';
import BoxHeader from '../../../../components/Layout/Components/Box/Header/BoxHeader';
import BoxHeaderIcon from '../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Box from '../../../../components/Layout/Components/Box/Box';
import { useParams } from 'react-router';
import useReduxReducer from '../../../../hooks/useReduxReducer';
import transactionDetailReducer from '../../../../store/reducers/pos/transactionDetail';
import styled from 'styled-components';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import TodayOutlinedIcon from '@material-ui/icons/TodayOutlined';
import Items from './Transaction/Items';

const BoxHeaderTitle = styled.h3`
  padding: 10px 0;
  margin: 0;
`;

const BoxBody = styled.div`
  padding: 20px;
`;

const BoxBodyLine = styled.div`
  display: flex;
  padding: 10px 0;
`;

const BoxBodyLineLabel = styled.div`
  font-weight: bolder;
  width: 20%;
`;

const Transaction = () => {
  let { id: transactionId } = useParams();
  const dispatch = useDispatch();
  const transactionDetail = useSelector((state) => state?.transactionDetail?.data?.transaction);

  useReduxReducer({ transactionDetail: transactionDetailReducer });

  useEffect(() => {
    dispatch(getTransactionDetail(transactionId));
  }, [dispatch, transactionId]);

  useEffect(() => {

  }, [transactionDetail]);

  return <>
    <Box>
      <BoxHeader>
        <BoxHeaderIcon color={'#43a047'}>
          <AssignmentIcon />
        </BoxHeaderIcon>
        <BoxHeaderTitle>
        {transactionDetail?.document_no}
        </BoxHeaderTitle>
      </BoxHeader>
      <BoxBody>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.id'} />:</BoxBodyLineLabel>
          {transactionDetail?.ID}
        </BoxBodyLine>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.documentNo'} />:</BoxBodyLineLabel>
          {transactionDetail?.document_no}
        </BoxBodyLine>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.createdOn'} />:</BoxBodyLineLabel>
          <FormattedDate value={transactionDetail?.created_on} /> <FormattedTime value={transactionDetail?.created_on} hour="numeric" minute="numeric" second="numeric" />
        </BoxBodyLine>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.createdBy'} />:</BoxBodyLineLabel>
          {transactionDetail?.created_by}
        </BoxBodyLine>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.closedOn'} />:</BoxBodyLineLabel>
          <FormattedDate value={transactionDetail?.modified_on} /> <FormattedTime value={transactionDetail?.modified_on} hour="numeric" minute="numeric" second="numeric" />
        </BoxBodyLine>
        <BoxBodyLine>
          <BoxBodyLineLabel><FormattedMessage id={'transaction.closedBy'} />:</BoxBodyLineLabel>
          {transactionDetail?.modified_by}
        </BoxBodyLine>
      </BoxBody>
    </Box>

    <Box style={{ marginTop: '50px' }}>
      <BoxHeader>
        <BoxHeaderIcon color={'#43a047'}>
          <TodayOutlinedIcon />
        </BoxHeaderIcon>

      </BoxHeader>
      <BoxBody style={{ padding: '20px 15px' }}>
        <Items data={transactionDetail?.lines} />
      </BoxBody>
    </Box>
  </>;
};

export default Transaction;
